<template>
  <div class="prescription-list-container">
    <el-tabs type="border-card"  v-model="activeTab">
      <el-tab-pane label="西药处方" name="western">
        <western-prescription />
      </el-tab-pane>
      <el-tab-pane label="中药处方" name="china">
        <china-prescription />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import westernPrescription from "../westernMedicineList/WesternMedicineList.vue";
import chinaPrescription from "../chinaMedicineList/ChinaMedicineList.vue";

export default {
  name: "PrescriptionList",
  components: {
    westernPrescription,
    chinaPrescription,
  },
  data() {
    return {
      activeTab: "western",
    };
  },
};
</script>

<style lang="less" scoped>
.prescription-list-container {
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.page-header h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #303133;
}
/deep/ .el-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .el-tabs__content {
    flex: 1;
    overflow-y: auto;
  }
}
</style>